import { TranslationFunction } from '~/utils/translate';
import { BlackbeardDistanceUnit, stringToValidDistanceUnit } from '../../../../types';

export interface ValidationInput2D {
  length: number;
  width: number;
  distanceUnit: BlackbeardDistanceUnit;
  t: TranslationFunction;
}

export interface ValidationOutput2D {
  errorLength?: string;
  errorWidth?: string;
  errorCombined?: string;
}

export type ExtraValidationFunction = (
  validate: (_: ValidationInput2D) => ValidationOutput2D,
  length: string,
  width: string,
  unit: string,
  t: TranslationFunction,
) => ValidationOutput2D;

export const extraValidationHelper: ExtraValidationFunction = (
  validate,
  length,
  width,
  unit,
  t,
) => {
  const input: ValidationInput2D = {
    length: Number(length),
    width: Number(width),
    distanceUnit: stringToValidDistanceUnit(unit),
    t,
  };

  return validate(input);
};

export const allowKeyboardNumberInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Enter',
    'Home',
    'End',
    '.',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ];
  if (!allowedKeys.includes(event.key) && !event.ctrlKey) {
    event.preventDefault();
  }
};
